import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import { LiveService } from '../service/live.service';
import { IRoom } from '../model/room.model';

@Component({
    selector: 'app-live-list-room',
    templateUrl: './live-list-room.component.html',
    styleUrls: ['./live-list-room.component.scss']
})
export class LiveListRoomComponent implements OnInit {
    projectId: string;
    roomList: IRoom[];
    defaultThumbnail = 'https://image.winudf.com/v2/image1/Y29tLmFzY2VuZGNvbW1lcmNlLndlbWFsbF9zY3JlZW5fMF8xNTY1ODM4NDQwXzAzNQ/screen-0.jpg?fakeurl=1&type=.jpg';
    displayName: string;
    userId: string;

    constructor(
      private route: ActivatedRoute,
      private liveService: LiveService) {
        this.projectId = this.route.snapshot.paramMap.get('projectId');
            this.route.queryParams.subscribe((params) => {
              this.displayName = params.displayName;
              this.userId = params.userId;
            });
    }

    ngOnInit(): void {
      this.loadAll();
    }

    loadAll() {
        const param = 'status.equals=LIVE_NOW&page=0&size=50&sort=numOfView,desc';
        this.liveService
            .getAllViewer(this.projectId, param)
            .subscribe((result) => {
                  this.roomList = result.body;
            });
    }

    getHost(): string {
        return window.location.origin;
    }

    navigate(room: IRoom) {
        const externalUrl = this.getHost() + '/rooms/' + room.projectId + '-' + room.id + '?userId=' + this.userId + '&displayName=' + this.displayName;
        window.open(externalUrl, '_self');
    }
}
